import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  color?: string;
}

const KlubIconLogo: NextPage<Props> = ({
  width = "100%",
  height = "100%",
  color = "#fff",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4154 48.5816H18.85L13.3001 54.8839L18.7683 63.7431H14.9956L10.994 57.3972L9.52744 58.9891V63.7431H6.32178V48.5762H9.52744V55.0693L15.4154 48.5762V48.5816Z"
        fill="#FF0C00"
      />
      <path
        d="M30.7731 61.0226V63.7431H21.0525V48.5762H24.2799V61.0172H30.7731V61.0226Z"
        fill="#FF0C00"
      />
      <path
        d="M40.9737 57.8174V48.582H44.2011V58.2808C44.2011 62.3042 41.8787 63.9997 38.0842 63.9997C33.8972 63.9997 32.1145 62.157 32.1145 58.199V48.5875H35.3638V57.7629C35.3638 60.129 35.9689 61.3011 38.215 61.3011C40.4612 61.3011 40.9791 60.298 40.9791 57.8228L40.9737 57.8174Z"
        fill="#FF0C00"
      />
      <path
        d="M46.8303 48.582H52.8436C56.4255 48.582 57.4286 50.2176 57.4286 52.2893C57.4286 54.3609 56.0875 55.4077 54.561 55.8275V55.8711C56.9707 56.1655 58.0774 57.4848 58.0774 59.5783C58.0774 62.6804 55.6459 63.7489 52.3584 63.7489H46.8303V48.582ZM54.2666 52.8126C54.2666 51.1771 53.1762 51.0735 51.7315 51.0735H50.0578V54.8461H51.2517C52.7619 54.8461 54.2666 54.5736 54.2666 52.8126ZM54.6427 59.2839C54.6427 57.5884 53.4706 57.294 52.0259 57.294H50.0578V61.252H51.7151C53.4761 61.252 54.6482 60.9358 54.6482 59.2839H54.6427Z"
        fill="#FF0C00"
      />
      <path
        d="M53.8232 21.1094C56.282 18.8905 57.8249 15.6958 57.8249 12.1466C57.8249 5.43545 52.3022 0 45.4929 0C42.4998 0 39.7521 1.0522 37.615 2.80223L37.6041 2.81313C37.5169 2.88401 34.6329 5.45181 31.9124 7.87786C29.192 5.45181 26.308 2.88401 26.2207 2.81313L26.2098 2.80223C24.0727 1.0522 21.3305 0 18.332 0C11.5227 0 6 5.4409 6 12.1466C6 15.6958 7.54284 18.8851 10.0016 21.1094C7.54284 23.3283 6 26.523 6 30.0722C6 36.7833 11.5227 42.2188 18.332 42.2188C21.325 42.2188 24.0727 41.1666 26.2098 39.4165L26.2207 39.4057C26.308 39.3348 29.192 36.767 31.9124 34.3409C34.6329 36.767 37.5169 39.3348 37.6041 39.4057L37.615 39.4165C39.7521 41.1666 42.4944 42.2188 45.4929 42.2188C52.3022 42.2188 57.8249 36.7779 57.8249 30.0722C57.8249 26.523 56.282 23.3337 53.8232 21.1094ZM18.3429 6.37861C20.0984 6.37861 21.3577 7.0819 22.1155 7.68705C22.5462 8.06868 24.667 9.955 27.1257 12.1466C24.6724 14.3328 22.5462 16.2246 22.1155 16.6062C21.3523 17.2168 20.0929 17.9146 18.3429 17.9146C15.0609 17.9146 12.395 15.325 12.395 12.1466C12.395 8.96822 15.0664 6.37861 18.3429 6.37861ZM22.1155 34.5263C21.3523 35.1369 20.0929 35.8347 18.3429 35.8347C15.0609 35.8347 12.395 33.2451 12.395 30.0667C12.395 26.8883 15.0664 24.2987 18.3429 24.2987C20.0929 24.2987 21.3523 25.002 22.1155 25.6071C22.5462 25.9888 24.667 27.8751 27.1257 30.0667C24.6724 32.2529 22.5462 34.1447 22.1155 34.5263ZM26.6569 21.1094C27.5674 20.3025 29.7917 18.3181 31.9233 16.4208C34.3875 14.2238 36.7155 12.1466 36.7155 12.1466C39.1742 9.96045 41.295 8.06868 41.7257 7.68705C42.4889 7.07645 43.7483 6.37861 45.4983 6.37861C48.7803 6.37861 51.4462 8.96822 51.4462 12.1466C51.4462 15.325 48.7749 17.9146 45.4983 17.9146C42.5053 17.9146 39.7576 18.9668 37.6205 20.7169L37.6096 20.7278C37.5932 20.7441 37.1843 21.1039 37.1843 21.1039C37.1843 21.1039 34.0495 23.8953 31.9179 25.7925C29.7917 23.8953 27.5673 21.9163 26.6514 21.1039L26.6569 21.1094ZM45.4983 35.8402C43.7483 35.8402 42.4889 35.1369 41.7257 34.5317C41.295 34.1501 39.1742 32.2638 36.7155 30.0722C39.1688 27.886 41.295 25.9942 41.7257 25.6126C42.4889 25.002 43.7483 24.3042 45.4983 24.3042C48.7803 24.3042 51.4462 26.8938 51.4462 30.0722C51.4462 33.2506 48.7749 35.8402 45.4983 35.8402Z"
        fill="url(#paint0_linear_5341_62812)"
      />
      <path
        d="M27.1202 12.1739C27.1202 12.1739 29.459 10.1023 31.9287 7.91609C29.2137 5.48458 26.3406 2.90588 26.2534 2.83501L26.2424 2.8241C24.1108 1.06862 21.3685 0.00551733 18.3755 6.55206e-05C11.5662 -0.0217417 6.02716 5.4028 6.0108 12.114C5.9999 15.6631 7.53184 18.8579 9.98515 21.0876C12.1822 19.1141 15.1098 17.9147 18.321 17.9256H18.3428C15.0608 17.9256 12.3948 15.336 12.3948 12.1576C12.3948 8.97919 15.0662 6.38958 18.3428 6.38958C20.0983 6.38958 21.3576 7.09287 22.1154 7.69802C22.5461 8.07964 24.6669 9.96597 27.1256 12.1576"
        fill="url(#paint1_linear_5341_62812)"
      />
      <path
        d="M27.1254 30.0453C24.6721 32.2315 22.5459 34.1232 22.1152 34.5049C21.3519 35.1155 20.0926 35.8133 18.3425 35.8133C15.0606 35.8133 12.3946 33.2237 12.3946 30.0453C12.3946 26.8669 15.066 24.2773 18.3425 24.2773H18.3207C15.1096 24.2882 12.182 23.0888 9.98491 21.1152C7.5316 23.345 5.99965 26.5398 6.01056 30.0889C6.03236 36.8001 11.5659 42.2192 18.3752 42.2028C21.3683 42.1919 24.1105 41.1343 26.2422 39.3788L26.2531 39.3679C26.3403 39.297 29.2134 36.7183 31.9284 34.2868C29.4588 32.1006 27.1199 30.0289 27.1199 30.0289"
        fill="url(#paint2_linear_5341_62812)"
      />
      <path
        d="M36.7159 30.0724C39.1692 27.8862 41.2954 25.9945 41.7261 25.6128C42.4893 25.0022 43.7487 24.3044 45.4988 24.3044C48.7808 24.3044 51.4467 26.894 51.4467 30.0724H57.8253C57.8253 23.3612 52.3026 17.9258 45.4933 17.9258C42.5003 17.9258 39.7525 18.978 37.6154 20.728L37.6045 20.7389C37.5173 20.8098 34.6333 23.3776 31.9128 25.8036L36.705 30.0779L36.7159 30.0724Z"
        fill="url(#paint3_linear_5341_62812)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5341_62812"
          x1="9.96346"
          y1="21.1094"
          x2="58.1792"
          y2="21.1094"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.48" stopColor="#FF0C00" />
          <stop offset="0.6" stopColor="#EB0D01" />
          <stop offset="0.76" stopColor="#CA1103" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5341_62812"
          x1="11.757"
          y1="10.5384"
          x2="34.093"
          y2="10.5384"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.48" stopColor="#FF0C00" />
          <stop offset="0.6" stopColor="#EB0D01" />
          <stop offset="0.76" stopColor="#CA1103" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5341_62812"
          x1="11.4896"
          y1="31.6536"
          x2="32.7462"
          y2="31.6536"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.48" stopColor="#FF0C00" />
          <stop offset="0.6" stopColor="#EB0D01" />
          <stop offset="0.76" stopColor="#CA1103" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5341_62812"
          x1="-0.160148"
          y1="23.9936"
          x2="25.7468"
          y2="23.9936"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.48" stopColor="#FF171B" />
          <stop offset="0.6" stopColor="#EB1412" />
          <stop offset="0.76" stopColor="#CA1103" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default KlubIconLogo;
